module.exports = "/_next/static/images/42c735ba264b5ff44613c2789d08aad1-multiproduct-lg.jpg.webp";